import { createReducer, on } from '@ngrx/store';
import {
  USER_FIND_SUCCESS,
  USER_FAILURE,
  USER_UPDATE_FORM,
  USER_RESET_ERROR,
  USER_RESET,
  USER_RESET_FORM,
  USER_FIND_ALL_SUCCESS,
  USER_EDIT_MODE,
  USER_CLEAR_STATE,
  USER_UPDATE_ID,
  USER_UPDATE_LOADING
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  Usuario,
  UsuarioForm,
} from '@core/models';
import { transformArrayUserData, transformUserData } from '@core/helpers';

export interface UserState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  userId: string | null;
  user: Usuario | null;
  userList: Usuario[];
  userForm: UsuarioForm | null;
  userInmutable: boolean,
  formValid: boolean,
  error: ResponseBadRequest | null;
}

export const initialState: UserState = {
  loading: false,
  isEditing: false,
  editMode: false,
  userId: null,
  user: null,
  userList: [],
  userForm: null,
  userInmutable: false,
  formValid: false, 
  error: null,
};

export const userReducer = createReducer(
  initialState,
  on(USER_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(USER_FIND_SUCCESS, (state, { user }) => ({ ...state, user: transformUserData(user) })),
  on(USER_FIND_ALL_SUCCESS, (state, { userList }) => ({ ...state, userList: transformArrayUserData(userList) })),
  on(USER_FAILURE, (state, { error }) => ({ ...state, error })),
  on(USER_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(USER_UPDATE_FORM, (state, { userForm }) => ({ ...state, userForm })),
  on(USER_UPDATE_ID, (state, { userId }) => ({ ...state, userId })),
  on(USER_RESET, (state) => ({ ...state, user: null, userId: null, userForm: null })),
  on(USER_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(USER_RESET_FORM, (state) => ({ ...state, userForm: null, loading: false })),
  on(USER_CLEAR_STATE, (state) => ({ ...state, ...initialState, loading: state.loading })),
);